export default {
  StreetAddressFormField__ARIA: "Street address",
  StreetAddressFormField__LABEL: "Street address",
};
